import {
  Box,
  Display,
  FontFamily,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React, { SyntheticEvent } from 'react'
import { useStore } from 'react-redux'
import { useTrackingHook } from '../../model/context/useTracking'

// A clickable box is not good for accessibility. If the Add A Protein experiment is productionised, find a better alternative.
// https://github.com/Gousto/gousto-webclient/pull/7741#discussion_r1409049037
const CustomiseButton = withCitrusTheme(Box, (theme) => ({
  zIndex: 11,
  color: theme.tokens.colors.Secondary_400,
  '&:hover': {
    color: theme.tokens.colors.Secondary_600,
    cursor: 'pointer',
  },
}))

const CustomiseButtonFineDineIn = withCitrusTheme(Box, (theme) => ({
  zIndex: 11,
  color: theme.tokens.colors.Secondary_200,
  '&:hover': {
    color: theme.tokens.colors.Secondary_400,
    cursor: 'pointer',
  },
}))

export type CustomiseButtonContainerProps = {
  recipeId: string
  onClick: (e: SyntheticEvent) => void
  isFineDineIn: boolean
}

export const CustomiseButtonContainer = ({
  recipeId,
  onClick,
  isFineDineIn,
}: CustomiseButtonContainerProps) => {
  const store = useStore()
  const { basket } = store.getState()

  const useTracking = useTrackingHook()
  const { useTrackCustomiseButtonClicked } = useTracking()
  const { trackCustomiseButtonClicked } = useTrackCustomiseButtonClicked()

  const trackClick = () => {
    trackCustomiseButtonClicked({
      actionType: 'ui_interaction',
      elementName: 'customise_recipe',
      recipeId: recipeId,
      menuId: basket.get('currentMenuId'),
      orderId: basket.get('orderId'),
    })
  }

  return (
    <Box onClick={onClick} display={Display.Flex} justifyContent={JustifyContent.FlexEnd}>
      {isFineDineIn ? (
        <CustomiseButtonFineDineIn data-testid="CustomiseButtonFineDineIn" onClick={trackClick}>
          <Text fontFamily={FontFamily.Bold}>Customise</Text>
        </CustomiseButtonFineDineIn>
      ) : (
        <CustomiseButton data-testid="CustomiseButton" onClick={trackClick}>
          <Text fontFamily={FontFamily.Bold}>Customise</Text>
        </CustomiseButton>
      )}
    </Box>
  )
}
